import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { RadioButtonPanels } from '@eika/radio-button';

import { EiendomBruk, EiendomBruk as Bruk } from '../../generated-types';
import { useTranslation } from '../../translations';

export type EiendomsBrukFormData = {
    eiendomBruk: EiendomBruk;
};

const EiendomsBruk: FC = () => {
    const { eiendomBruk, validationMessage } = useTranslation();
    const {
        control,
        formState: { errors },
    } = useFormContext<EiendomsBrukFormData>();

    return (
        <Controller
            name="eiendomBruk"
            control={control}
            rules={{
                validate: { ikkeValgt: (value: Bruk) => value !== undefined },
            }}
            render={({ field: { onChange, value } }) => (
                <RadioButtonPanels
                    label={eiendomBruk.label}
                    selectedOption={value}
                    onChange={(value) => onChange(value as Bruk)}
                    options={[
                        { label: eiendomBruk.selectValueBo, value: Bruk.BO },
                        { label: eiendomBruk.selectValueUtleie, value: Bruk.UTLEIE },
                        { label: eiendomBruk.selectValueFritid, value: Bruk.FRITID },
                    ]}
                    errorMessage={errors.eiendomBruk?.type === 'ikkeValgt' ? `${validationMessage.requiredChoose}` : ''}
                />
            )}
        />
    );
};

export default EiendomsBruk;
